import { useTranslation } from 'react-i18next';
import Icon from 'components/Icon';
import FullAccess from '../assets/fullAccess.png';
import { Wrapper, Header, Container, Img, Title, Description, Supporter } from './index.view';

const ErrorFullAccess = () => {
  const { t } = useTranslation();
  const contactEmail = () => <Supporter href="mailto:support@fanz.io">support@fanz.io.</Supporter>;

  return (
    <Wrapper>
      <Header>
        <Icon name="logo" />
      </Header>
      <Container maxWidth="md">
        <Img src={FullAccess} alt="fullAccess" />

        <Title>{t('errorFullAccessTItle')}</Title>

        <Description>
          {t('errorFullAccessDescription')}
          {contactEmail()}
        </Description>
      </Container>
    </Wrapper>
  );
};

export default ErrorFullAccess;
